import { render, staticRenderFns } from "./FeatureCardView.vue?vue&type=template&id=3ca0b1e8&scoped=true"
import script from "./FeatureCardView.vue?vue&type=script&lang=ts"
export * from "./FeatureCardView.vue?vue&type=script&lang=ts"
import style0 from "./FeatureCardView.vue?vue&type=style&index=0&id=3ca0b1e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca0b1e8",
  null
  
)

export default component.exports